import _ from 'lodash'

const fillEditPropertyModal = (properties: any[], propertyID: number): { modal: any, initialState: Record<string, any> } => {
    const currentProperty = _.find(properties, (property: any) => property.id === propertyID)
    const attributes = currentProperty?.attributes ?? {}

    const initialState = {
        ...attributes,
        // Transitional bridge: "areas" (new selector field) should be prefilled from legacy "Area"
        // when explicit migrated value is not present yet.
        areas: attributes.areas ?? attributes.Area
    }

    return {
        modal: {},
        initialState
    }
}

export default fillEditPropertyModal
